import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MenuComponent } from '../MenuComponent';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';


export class LH_DecantPallet extends Component {
    static displayName = LH_DecantPallet.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            recentShipments: [],
            selectedContainerRef: ""
        }
    }

    componentDidMount() {
        this.loadRecentShipments();
    }
    goto(page) {
        this.history.push({
            pathname: page,
            state: this.state
        });
    }

    async loadRecentShipments() {
        this.state.loading = true;


        fetch(`api/LinenhouseXdoc/GetRecentShipments`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ openASN: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;

                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ recentShipments: data, alertMessage: "" });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load ASN containers!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load ASN containers!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ openASN: [], alertMessage: error });
            });
    }

    selectASN(selectedRow) {

        this.state.selectedContainerRef = selectedRow.containerref;
        this.goto('../LinenhouseXdoc/LH_DecantBuildArray');
    }
    render() {



        let recentShipmentsHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderRecentShipments();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h4>Decant Pallets</h4></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../LinenhouseXdoc/LH_LoadOpenASN'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {recentShipmentsHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

    renderRecentShipments() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Select Container</label>
                                <br />
                                <input className="col-sm-4" ref="containerRefInput" value={this.state.selectedContainerRef} onChange={(e) => { this.setState({ selectedContainerRef: e.target.value }); }} />
                            </th>


                        </tr>
                    </thead>
                    <tbody>
                        {this.state.recentShipments
                            .filter((item) =>
                            (!this.state.selectedContainerRef.length ||
                                item.containerref
                                    .toString()
                                    .toLowerCase()
                                    .includes(this.state.selectedContainerRef.toString().toLowerCase()))).map(row =>
                                        <tr key={row.containerref} onClick={() => { this.selectASN(row) }}>
                                            <td>{row.containerref}</td>
                                        </tr>
                                    )}
                    </tbody>
                </table>
            </div>
        );
    }


}
